export default __webpack_public_path__ + "static/media/frg--sales-display.d84789c2.png";